import { z } from "zod";

import { CUSTOM_MANIFEST_AUTH_TYPES } from "../../../../shared/domain/tools/external-tool-auth";
import { CustomManifestKeysSchema } from "./Keys.schema";
import { CustomManifestNoneSchema } from "./None.schema";
import { CustomManifestOAuthSchema } from "./OAuth.schema";
import { CustomManifestServiceHttpSchema } from "./ServiceHttp.schema";
import { CustomManifestUserHttpSchema } from "./UserHttp.schema";
import { CustomManifestUserOAuthSchema } from "./UserOAuth.schema";

/**
 * Zod enum for the inner auth discriminant of CUSTOM_MANIFEST tools.
 * Derived from CUSTOM_MANIFEST_AUTH_TYPES — single source of truth.
 * Use this anywhere you need to validate or enumerate auth type values.
 */
export const CustomManifestAuthTypeSchema = z.enum(CUSTOM_MANIFEST_AUTH_TYPES);

/**
 * CustomManifest tool auth — inner discriminant on auth.type.
 *
 * Second level of discrimination for CUSTOM_MANIFEST tools.
 * The outer discriminant is tool.type = CUSTOM_MANIFEST (the DB enum column).
 * This inner discriminant is auth.type (the JSON field) which tells the runtime
 * which HTTP auth mechanism to use when executing requests.
 *
 * All variant-specific fields are optional: marketplace tools may be created
 * with partial config, and historical records may predate field additions.
 */
export const CustomManifestAuthSchema = z.discriminatedUnion("type", [
  CustomManifestOAuthSchema,
  CustomManifestServiceHttpSchema,
  CustomManifestUserHttpSchema,
  CustomManifestUserOAuthSchema,
  CustomManifestKeysSchema,
  CustomManifestNoneSchema
]);

export type CustomManifestAuth = z.infer<typeof CustomManifestAuthSchema>;
